import { Config } from '@oscar/request';
import { useQuery } from 'hooks';
import React from 'react';

export default function PrivateRoute({
  component,
  ...props
}: {
  component: React.ReactElement;
  [name: string]: any;
}) {
  const [queries] = useQuery();
  if (Config.getInstance().getTokenValue()) {
    return React.cloneElement(component, { ...props, ...queries });
  }
  return null;
}
